import { StoreState } from '@/core/models/store.interface';
import { JobFunctionCategory } from '@nxtpeople/nxt-styles';
import { Module } from 'vuex';
import { JOB_FUNCTION_INCLUDES, JobFunctionService } from './job-function.service';

const service = new JobFunctionService();

export interface JobFunctionState {
   jobFunctionCategories: Array<JobFunctionCategory>;
}

const JobFunctionStore: Module<JobFunctionState, StoreState> = {
   namespaced: true,
   state: {
      jobFunctionCategories: [],
   },
   getters: {},
   mutations: {
      SET_JOB_FUNCTION_CATEGORIES(state, jobFunctions: Array<JobFunctionCategory>) {
         state.jobFunctionCategories = jobFunctions;
      },
   },
   actions: {
      async getJobFunctionCategories(context, query) {
         const response = await service.getAll({ ...query, per_page: 9999, page: 1, include: JOB_FUNCTION_INCLUDES.join(',') });
         context.commit('SET_JOB_FUNCTION_CATEGORIES', response.data);
         return response;
      },
      async search(context, query) {
         const response = await service.search({ ...query, per_page: 9999, page: 1, include: JOB_FUNCTION_INCLUDES.join(',') });
         context.commit('SET_JOB_FUNCTION_CATEGORIES', response.data);
         return response;
      },
   },
};

export default JobFunctionStore;
